import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { workSchedulesService } from '../api/workSchedules.service';
import { WORK_SCHEDULES_KEYS } from './queryKeys';

/**
 * Fetches the tenant work schedule for the active organization.
 * Disabled when no organization is active.
 */
export function useTenantWorkSchedule() {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: WORK_SCHEDULES_KEYS.tenant(orgId),
    queryFn: ({ signal }) => workSchedulesService.getTenant(signal),
    staleTime: 60_000,
    enabled: !!orgId,
  });
}
